// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// The generated `Database` type lags behind the migrations (it's regenerated
// out-of-band via `supabase gen types typescript`). Until that pipeline runs
// per-PR, we widen `from` and `rpc` so callers can target tables / RPCs the
// generator doesn't know about (`merchant_memberships`, `claude_messages`,
// etc.). The escape hatches are intentional and scoped to this single file —
// every other module gets the precise PostgrestQueryBuilder typings.
type AppSupabaseClient = ReturnType<typeof createClient<Database>> & {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  from: (relation: string) => any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  rpc: (fn: string, args?: Record<string, unknown>) => any;
};

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
}) as AppSupabaseClient;